// 纯数据提交传递
export const COMMIT_PURE_DATA = 'COMMIT_PURE_DATA'
// 用户登录
export const USER_LOGIN = 'USER_LOGIN'
// 用户退出
export const USER_LOGIN_OUT = 'USER_LOGIN_OUT'
// 用户免登陆
export const CUSTOMER_LOGIN = 'CUSTOMER_LOGIN'



// WEBPACK FOOTER //
// ./src/store/mutation-type.js